import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=4967cf03&scoped=true&"
import script from "./PhoneIcon.vue?vue&type=script&lang=js&"
export * from "./PhoneIcon.vue?vue&type=script&lang=js&"
import style0 from "./PhoneIcon.vue?vue&type=style&index=0&id=4967cf03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967cf03",
  null
  
)

export default component.exports